module.exports = __webpack_public_path__ + "static/media/undraw-visual-data-b-1-wx.a16dca53.svg";